<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'用户管理'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item  label="用户编码">
							    <el-input clearable v-model="q.usercodeLike"></el-input>
							</el-form-item>
							<el-form-item label="用户名称">
							    <el-input clearable v-model="q.usernameLike"></el-input>
							</el-form-item>
							<el-form-item label="邮箱">
							    <el-input clearable v-model="q.email"></el-input>
							</el-form-item>
                            <el-form-item label="用户类型">
                                <!-- 因为只保留内部用户和经销商，所以改为这样选取 -->
                                <el-select clearable v-model="q.usertype" placeholder="请选择">
                                    <el-option label="内部用户" :value="0"></el-option>
                                    <el-option label="经销商" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="　联系人电话">
                                        <el-input clearable v-model="q.phone"></el-input>
                                    </el-form-item>
                                    <el-form-item label="状态">
                                        <brselect clearable category="zhuangtai_type" :v="q.status" v-model="q.status"></brselect>
                                    </el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                        </div>
                        <div class="l-retrieval">
                             <el-button class="h-btn h-formBtn h-bgwhite" @click="handleReset">重置</el-button>
                             <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                             <el-button class="h-btn h-formBtn h-bggreen" @click="handleAdd">新增</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30">
            <el-table
                    :data="tableData"
                    stripe
                    style="width: 100%"
					border
            >
                <el-table-column
                        type="index"
                        label="#"
						fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="usercode"
                        label="用户编码"
						fixed
                        width="140"
						:show-overflow-tooltip="true">
                </el-table-column>
<!--                <el-table-column-->
<!--                        prop="password"-->
<!--                        label="密码"-->
<!--                        width="120"-->
<!--						:show-overflow-tooltip="true">-->
<!--                </el-table-column>-->
                <el-table-column
                        prop="status"
                        width="80"
                        label="用户状态"
						:show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{scope.row.status|dictname('zhuangtai_type')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="username"
                        label="用户名称"
                        width="130"
						:show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.username}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
                        prop="email"
                        label="邮箱"
                        width="180"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="联系人电话"
                        width="120"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="deptname"
                        label="部门名称"
                        width="100"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        width="160"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="ldate"
                        label="更新时间"
                        width="160"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="accountdate"
                        label="账户有效期"
                        width="110"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="luname"
                        label="更新人"
                        width="110"
						:show-overflow-tooltip="true">
                </el-table-column>


                <el-table-column
                        fixed="right"
                        label="操作"
                        width="130"
                >

                    <template slot-scope="scope">
                        <el-button
                            class="h-tableLink h-btn" v-if="scope.row.status == '1'"
                            @click="freezeOrThaw(scope.row,0)">冻结</el-button>
                        <el-button
                            class="h-tableLink h-btn" v-if="scope.row.status == '0'"
                            @click="freezeOrThaw(scope.row,1)">解冻</el-button>
                        <el-button
                                class="h-tableLink h-btn"
                                @click="handleEdit(scope.row)">授权</el-button>

                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button type="primary" @click="exportExcel">批量导出</el-button>
                </div>
                <div class="h-pagination2">
                    <pagination :page="q" @query="query"/>
                </div>
            </div>
        </div>

        <!-- 新增用户弹窗 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="addDialogVisible" class="h-dialog2 abnormal-dialog" width="500px">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>新增用户</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine h-mrb-38">
                <el-form :model="addForm" :rules="addRules" ref="addForm" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                    <el-form-item label="工号" class="h-elformWrap-1" prop="usercode">
                        <el-input v-model="addForm.usercode" placeholder="请输入工号"/>
                    </el-form-item>
                    <el-form-item label="姓名" class="h-elformWrap-1" prop="username">
                        <el-input v-model="addForm.username" placeholder="请输入姓名"/>
                    </el-form-item>
                    <el-form-item label="邮箱" class="h-elformWrap-1" prop="email">
                        <el-input v-model="addForm.email" placeholder="请输入邮箱"/>
                    </el-form-item>
                    <el-form-item label="联系人电话" class="h-elformWrap-1" prop="phone">
                        <el-input v-model="addForm.phone" placeholder="请输入联系人电话"/>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-formBtn h-bgwhite" @click="addDialogVisible = false">取消</el-button>
                <el-button class="h-btn h-formBtn h-bggreen" @click="submitAdd">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import ss from '../../api/SystemService';
    import updownfile from "../../utils/updownfile";
    export default {
        components: {},
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //查询属性

                q: {
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                f: {
                    usercode:null,
                    password:null,
                    usertype:null,
                    username:null,
                    email:null,
                    phone:null,
                    deptcode:null,
                    userdept:null,
                    deptname:null,
                    firstline:null,
                    secondline:null,
                    status:null,
                    organization:null,
                    cdate:null,
                    ldate:null,
                    logintimes:null,
                    lastlogintime:null,
                    accountdate:null,
                    area:null,
                    lucode:null,
                    countrytype:null,
                },
                //table列表
                tableData: [],
                //操作标志
                optflag:'save',
                // 新增用户相关
                addDialogVisible: false,
                addForm: {
                    usercode: '',
                    username: '',
                    email: '',
                    phone: ''
                },
                addRules: {
                    usercode: [{ required: true, message: '请输入工号', trigger: 'blur' }],
                    username: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    email: [
                        { required: true, message: '请输入邮箱', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
                    ]
                },
            }
        },
        created() {
            this.query();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            query(p) {
                ss.UserService.selectAllPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.query();
            },
            handleReset() {
                this.q = {
                    usertype: 0,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                };
                this.query();
            },
            handleEdit(r){
                this.$router.push({path: '/basic/user_grant', query: {usercodedata:r.usercode} });
            },
            freezeOrThaw(query,aaa) {
                let tipText = aaa === 0 ? '确定要冻结该用户吗？' : '确定要解冻该用户吗？';
                this.$confirm(tipText, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let q = {
                        usercode:query.usercode,
                        aaa:aaa,
                    }
                    ss.UserService.freezeOrThaw(q).then(rd=>{
                        if(rd.f){
                            this.$message({
                                message: '操作成功!',
                                type: 'success'
                            });
                            this.query();
                        }
                    })
                }).catch(() => {});
            },
            //批量导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/basic/bscUserInfo/downloadExcel", this.q, "post");
            },
            // 新增用户
            handleAdd() {
                this.addForm = {
                    usercode: '',
                    username: '',
                    email: '',
                    phone: ''
                };
                this.addDialogVisible = true;
                this.$nextTick(() => {
                    this.$refs.addForm && this.$refs.addForm.clearValidate();
                });
            },
            // 提交新增
            submitAdd() {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        ss.UserService.addInternalUser(this.addForm).then(rd => {
                            if (rd.f) {
                                this.$message.success(rd.msg || '新增成功');
                                this.addDialogVisible = false;
                                this.query();
                            } else {
                                this.$message.error(rd.msg || '新增失败');
                            }
                        });
                    }
                });
            },
        }
    }
</script>
<style>
.abnormal-dialog .h-dialogImg {
    background-size: cover;
}
</style>
